import providerQuickform  from "./provider-quickform.html";

const dialog               = require ('../../../../../components/dialog/dialog')
const quickformEntity      = require ('../../../../../components/quickform/quickform-entity')
const quickformHandler     = require ('../../../../../components/quickform/quickform-handler')
const {formCopy}           = require('./provider-quickform-form') 
const {form}               = require('./provider-quickform-form')




/****************ELEMENTS*****************/
var htmlQf   = {}         
var HTMLwasSelected = false

function HTMLselect(detail){ 

      
	quickformHandler.HTMLselect(

            'provider', //database table name****
            'provider-quickform', 
            detail.ev.target, //source, for example AC
             providerQuickform, 
             form, 
             formCopy, 
             htmlQf)

	HTMLwasSelected   = true  


}/**/


export function start(detail){  //console.log('Fullcont mini -dt 555555555555555555555555>',)
  
      if(!HTMLwasSelected) { HTMLselect(detail) }
       
      obj[detail.act].start(detail)
}/**/

const obj = {

      addOne:           { start: (detail)=>{  addOne(detail,htmlQf)                          }},
      hide:             { start: (detail)=>{  quickformEntity.hide(detail, htmlQf)           }},
      prepareAdd:       { start: (detail)=>{  quickformEntity.prepareAdd(detail, htmlQf)     }}

}/**/



function addOne(detail, htmlQf){

      quickformEntity.addOne(detail, htmlQf);
                   
}

